// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"182":"36feaad2","226":"b87333af","352":"ec056473"}[chunkId] + ".css";
};